import { orderBy } from 'lodash'
import { useMemo } from 'react'
import { reportCategory } from 'src/api'
import { useNewApiClient } from 'src/hooks/useNewApiClient'
import useSWRImmutable from 'swr/immutable'

const reportCategorySorter = (
  report_caregories: reportCategory[]
): reportCategory[] => {
  const sorted_report_categories = report_caregories.map((v) => {
    return {
      category_type: v.category_type,
      account_items: orderBy(
        v.account_items,
        ['order_no', 'id'],
        ['desc', 'asc']
      )
    }
  })

  return sorted_report_categories
}
export const useAdminUltraReportCategories = (userId: number) => {
  const { apiClient } = useNewApiClient()

  const { data: report_categories } = useSWRImmutable(
    `/zo_admin/ultra/report_categories/${userId}`,
    async () => {
      if (userId === undefined) return
      try {
        const res = await apiClient.admin.getZoAdminUltraReportCategories(
          userId
        )
        return res.report_categories
      } catch (err) {
        console.error(err)
      }
    }
  )

  const sorted_report_category = useMemo(() => {
    return reportCategorySorter(report_categories || [])
  }, [report_categories])

  const flatten_report_categories = useMemo(() => {
    return sorted_report_category?.flatMap((v) => v.account_items)
  }, [sorted_report_category])

  return {
    flatten_report_categories,
    sorted_report_category,
    report_categories
  }
}
